import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { TUIFriendService, TUIStore, StoreName, TUITranslateService, TUIUserService } from '@tencentcloud/chat-uikit-engine';
import { reactive, ref, watchEffect } from '../../../adapter-vue';
import { Toast, TOAST_TYPE } from '../../common/Toast/index';
import TUICore from '@tencentcloud/tui-core';
import SelectUser from '../../common/SelectUser/index.vue';
import Server from '../server';
import { get_user_list } from '@/api/apis';
import { useUserStore } from '@/store/user';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    var userStore = useUserStore();
    var TUIContactServer = Server.getInstance();
    var TUIConstants = TUIContactServer.constants;
    var needSearch = ref(false);
    var friendList = ref([]);
    var userList = ref([]);
    var chooseUserList = ref([]); //选中的用户列表
    var blkUserList = ref([]); //百林客用户列表
    var TUISearchServer = ref(null);
    var selectOptions = ref({
      isRadio: false,
      isNeedSearch: false,
      title: ''
    });
    var search = reactive({
      page: 1,
      limit: 50,
      total: 0
    });
    var generateSearchServer = isNeedSearch => {
      TUISearchServer.value = TUICore.getService(TUIConstants.TUISearch.SERVICE.NAME);
      if (TUISearchServer.value) {
        needSearch.value = isNeedSearch;
      } else {
        console.warn('请添加 TUISearch 组件');
      }
    };
    watchEffect(() => {
      var params = TUIContactServer.getOnCallParams(TUIConstants.TUIContact.SERVICE.METHOD.SELECT_FRIEND);
      selectOptions.value.title = params.title;
      selectOptions.value.isRadio = params.isRadio;
      selectOptions.value.isNeedSearch = params.isNeedSearch;
      if (params.isNeedSearch) {
        generateSearchServer(params.isNeedSearch);
      }
      TUIFriendService.getFriendList().then(res => {
        friendList.value = res.data.map(item => item.profile);
        userList.value = friendList.value;
      }).catch(err => {
        console.warn('getFriendList error:', err);
      });
    });
    var handleSelectedResult = memberList => {
      TUIStore.update(StoreName.CUSTOM, 'isShowSelectFriendComponent', false);
      var callback = TUIContactServer.getOnCallCallback(TUIConstants.TUIContact.SERVICE.METHOD.SELECT_FRIEND);
      callback && callback(memberList);
    };
    var searchFail = () => {
      Toast({
        message: TUITranslateService.t('TUIGroup.该用户不存在'),
        type: TOAST_TYPE.ERROR
      });
      userList.value = [...friendList.value];
    };
    var handleSearch = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (val) {
        console.log("开始搜索了之发起群聊发起单聊");
        if (!val) {
          return userList.value = friendList.value;
        }
        getblkUserList(val);
        // try {
        //   const imResponse: any = await TUISearchServer.value.searchUser(val)
        //   if (!imResponse.data[0]) {
        //     return searchFail()
        //   }
        //   userList.value = imResponse.data
        //   const searchAllResult = friendList.value.filter((item: any) => item.userID === imResponse.data[0].userID)
        //   friendList.value = searchAllResult.length ? friendList.value : [...friendList.value, ...userList.value]
        // } catch (error) {
        //   return searchFail()
        // }
      });
      return function handleSearch(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    // 获取百林客的用户列表
    var getblkUserList = val => {
      var obj = {
        page: search.page,
        limit: search.limit,
        key_word: val
      };
      get_user_list(obj).then(res_blk => {
        console.log("获取的用户列表", res_blk);
        search.total = res_blk.data.total;
        var member = res_blk.data.data;
        var userids = member.map(x => x.name);
        var can_member = [];
        TUIUserService.getUserProfile({
          userIDList: userids
        }).then(res_ => {
          console.log("2er--->", res_);
          can_member = JSON.parse(JSON.stringify(res_.data));
          console.log("搜索到的用户列表中已登录IM的人员--->", can_member);
          member = member.filter(x => {
            var index_ = can_member.findIndex(m => m.userID == x.name);
            if (index_ != -1) {
              return x;
            }
          });
          if (!selectOptions.value.isRadio) {
            member = member.filter(x => x.name != userStore.info.name);
          }
          member.forEach(x => {
            x.nick = x.name;
            x.userID = x.name;
          });
          console.log("can_member->", can_member, 'member->', member);
          userList.value = JSON.parse(JSON.stringify(member));
        });
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SelectUser, {
        isRadio: _unref(selectOptions).isRadio,
        isNeedSearch: _unref(selectOptions).isNeedSearch,
        title: _unref(selectOptions).title,
        userList: _unref(userList),
        onSearch: handleSearch,
        onComplete: handleSelectedResult
      }, null, 8, ["isRadio", "isNeedSearch", "title", "userList"]);
    };
  }
});